export default "/images/pause.svg?2550f2a2ba04229047d1d98a6aa5a8b8";